//对字符串扩展
String.prototype.isOK = function () {
    return 'OK' == this;
}
String.prototype.isNoResultSet = function () {
    return 'ERR099' == this;
}

function getErrors(serverErrors, filedName) {
    if (Array.isArray(serverErrors))
        return serverErrors.filter((err) => err.field == filedName)
    else {
        var dots = filedName.split('.');
        if (dots.length == 1) {
            if (serverErrors.filedName) {
                return serverErrors.filedName;
            } else {
                var errs = [];
                Object.keys(serverErrors).forEach(key => {
                    if (!Array.isArray(serverErrors[key]) && serverErrors[key].field == filedName)
                        errs.push(serverErrors[key]);
                });
                return errs;
            }
        } else {
            return getErrors(serverErrors[dots[0]], filedName.substring(dots[0].length + 1));
        }
    }
}

function getErrorMsgs(serverErrors, filedName) {
    var errors = getErrors(serverErrors, filedName);
    if (errors) return errors.map((err) => err.msg);
    else return [];
}

export default {
    getErrors,
    getErrorMsgs
}